import React, {useState, useContext, useEffect} from "react";
import {Radio, RadioGroup, FormControlLabel, FormLabel, TextField, InputLabel, MenuItem, FormControl, Select, Button, DialogTitle, Dialog, DialogActions, DialogContent, DialogContentText, Backdrop, CircularProgress  } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import {AuthContext} from '../context/AuthContext';
import ToastService from "react-material-toast";
import { usePaystackPayment } from 'react-paystack';
import bg from "../img/bg2.png";
import NavBars from "../components/NavBars";
import axios from "axios";
import { useParams } from 'react-router-dom';
import dayjs from "dayjs";
import { Footer } from "../components/Footer";

const toast = ToastService.new({
    place: "topRight",
    duration: 1,
    maxCount: 1,
  });

function SelfService() {
    const { id } = useParams();
    const [first_name, setFirstname] = useState("");
    const last_name = "RentSimConnect";
    const [email, setEmail] = useState("");
    const [sex, setSex] = useState("male");
    const [country, setCountry] = useState("");
    const [foreign_phone_number, setForeignPhone] = useState("");
    const [host_location, setHostLocation] = useState("");
    const host_contact = "1234567890"
    const [date_of_arrival, setArrivalDate] = useState(dayjs());
    const [date_of_departure, setDepartureDate] = useState();
    const time_of_arrival = "08:00";
    const time_of_departure = "17:00";
    const [service, setService] = useState("");
    const [rented_item, setRentedItem] = useState("");
    const [paymentMode, setPaymentMode] = useState("");
    const [ref, setTransRef] = useState("");
    const [status, setPaymentStatus] = useState("");
    const {onBoardClientSelfService, isLoading, baseURL, publicKey, secretKey, cashEnabled, rateURL} = useContext(AuthContext);
    const [open, setOpen] = React.useState(false);
    const [openCash, setOpenCash] = useState(false);
    const [openPOS, setOpenPOS] = useState(false);
    const [rates, setRates] = useState([]);
    const [data, setData] = useState([]);

    const getProductById = async (id) => {
        try {
            const response = await axios.get(`${baseURL}/restsimproduct/${id}`,{
                headers:{
                    "Content-Type": "application/json",
                    Accept: "application/json",
                }
            });
            if (response.status === 200){
                let data = response.data
                setData(response.data);
                setRentedItem(data.name);
                setService(data.name)
            }
        } catch (error) {
            console.log(error);
        }
    }
      

//Modal
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
      setOpen(false);
  };

    const handleOpenCash = () => {
        setOpenCash(true);
    };

    const handleCloseCash = () => {
        setOpenCash(false);
    };
    const handleOpenPOS = () => {
        setOpenPOS(true);
    };

    const handleClosePOS = () => {
        setOpenPOS(false);
    };


//Modal

  const handlePaymentMethod = (event) => {
    setPaymentMode(event.target.value);
  };

  const handleArrivalDate = (newDate) => {
    setArrivalDate(newDate);
  };

  const handleDepartureDate = (event) => {
    setDepartureDate(event);
  };

    // currency convertor function
  const getExchangeRates = async () => {
    await fetch(`${rateURL}/pair/GHS/USD`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setRates(res.conversion_rate);
        console.log("Exchange Rate: ", res.conversion_rate);
      })
      .catch((err) => {
        console.log(err);
      });
  };


   // other variables
  let payment_method = paymentMode;
  let payment_status = status;
  let trans_ref = ref;
  let payment_amount = data.price;

    let finalAmount = payment_amount * 100;
    
  useEffect(() => {
    getExchangeRates();
    getProductById(id)
    //eslint-disable-next-line
  }, []);

  
  function afterPayment() {
    // event.preventDefault();
    if ( payment_amount === "NaN"){
            toast.error("Date fields cannot be empty");
    }else if(first_name === '' || last_name === '' || email === '' || date_of_arrival === '' || date_of_departure === '' || rented_item === '' || paymentMode === '' || foreign_phone_number === '' || host_location === ''){
        toast.error("All fields are required!");
    }else if (date_of_arrival === undefined || date_of_departure === undefined){
        toast.error("Date fields cannot be empty or have default values");
    }else{
    onBoardClientSelfService(
        first_name,
        last_name,
        email,
        sex,
        country,
        foreign_phone_number,
        host_contact,
        host_location,
        date_of_arrival,
        date_of_departure,
        time_of_arrival,
        time_of_departure,
        rented_item,
        payment_method,
        parseFloat(payment_amount),
        payment_status,
        trans_ref,
        // event
    );
    }
  }


   //Paystack
    const config = {
      reference: (new Date()).getTime().toString(),
      email: email,
      amount: finalAmount, 
      publicKey: publicKey,
      secretKey: secretKey,
      currency: 'GHS',
    };

  

  const onSuccess = (reference) => {
    setTransRef(reference.reference);
    setPaymentStatus(reference.status);
    handleClose();
    afterPayment();
  };

  const onClose = () => {

    console.log('closed')
  }

  const initializePayment = usePaystackPayment(config);
  return (
    <div className="d-flex flex-column min-vh-100">
        <NavBars/>
        <div className="main-container flex-grow-1">
         <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
        
        <header className="mt-5" >
        </header>
        <div className="form-container" style={{maxWidth: "400px"}} >
            <form>
                <TextField
                    type='text'
                    label="Name"
                    placeholder='Name'
                    fullWidth
                    required
                    className='mb-3'
                    value={first_name}
                    onChange={(e) => setFirstname(e.target.value)}
                    
                />
                <TextField
                    type='email'
                    label="Email Address"
                    placeholder='Email Address'
                    variant="outlined"
                    fullWidth
                    required
                    className='mb-3'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    
                />
                <div className="mb-3">
                    <FormLabel >Sex</FormLabel>
                    <RadioGroup
                    defaultValue="male"
                    >
                        <FormControlLabel value="male" control={<Radio />} label="Male" onClick={() => setSex("male")} />
                        <FormControlLabel value="female" control={<Radio />} label="Female" onClick={() => setSex("female")}/>
                    </RadioGroup>
                </div>
                <TextField
                    type='text'
                    label="Country"
                    placeholder='Country'
                    fullWidth
                    required
                    className='mb-3'
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                />
            
                <div className="input-filed" >
                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                        <DatePicker
                            label="Date of Arrival"
                            value={date_of_arrival}
                            onChange={handleArrivalDate}
                            renderInput={(params) => <TextField {...params} fullWidth required />}
                            
                        />
                    </LocalizationProvider>
                    
                </div>
                <div className="input-filed" >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Date of Departure"
                            value={date_of_departure}
                             onChange={handleDepartureDate}
                            renderInput={(params) => <TextField {...params} fullWidth required/>}
                        />
                    </LocalizationProvider>
                    
                </div>
                <TextField
                    type='text'
                    label="Product"
                    fullWidth
                    required
                    className='mb-3'
                    value={service}
                    InputProps={{
                        readOnly: true,
                    }}
                />
                
                <div className="mb-3">
                    <FormLabel  >Foreign Phone Number</FormLabel>
                    <PhoneInput
                        placeholder="Phone Number"
                        defaultCountry="GH"
                        className="phone-input"
                        value={foreign_phone_number}
                        onChange={setForeignPhone}
                        limitMaxLength
                    />
                </div>
                <TextField
                    type='text'
                    label="Host Location/Address"
                    placeholder='Host Location'
                    fullWidth
                    required
                    className='mb-3'
                    value={host_location}
                    onChange={(e) => setHostLocation(e.target.value)}
                />
                <div className="input-filed">
                    <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label" >Select Method of Payment</InputLabel>
                            <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={paymentMode}
                            label="Select Method of Payment"
                            onChange={handlePaymentMethod}
                            >
                            {cashEnabled && (
                                <MenuItem value="Cash" onClick={handleOpenCash}>
                                    Cash
                                </MenuItem>
                            )}

                            <MenuItem value="POS" onClick={handleOpenPOS} >POS</MenuItem>
                            <MenuItem value="Card" onClick={handleClickOpen} >Card</MenuItem>
                            <MenuItem value="Mobile Money" onClick={handleClickOpen}>Mobile Money</MenuItem>
                            </Select>
                        </FormControl>
                </div>
            </form>
            <div className="input-filed subBtn">
                <button type="submit" className="btn btn-primary w-100" onClick={(e) => {afterPayment()}} >Submit</button>
            </div>
                
        </div>
        <div className="watermark">
            <img src={bg} alt="watermark" />
        </div>
        {/* Modal  */}
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        onClose(event, reason)
                    }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                disableEscapeKeyDown = {true}
            >
                <DialogTitle id="alert-dialog-title">
                {"Confirm to Make Payment"}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Amount: <span className="amount">GH₵{payment_amount}</span>
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    Amount in Dollars: <span className="amount" > ${(payment_amount * rates).toFixed(2)} </span> 
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={() => {
                    setPaymentMode("");
                    handleClose();
                }}>Cancel</Button>
                <Button onClick={()=>{initializePayment(onSuccess, onClose)}} autoFocus>
                    Make Payment
                </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openCash}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        onClose(event, reason)
                    }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                disableEscapeKeyDown = {true}
            >
                <DialogTitle id="alert-dialog-title">
                {"Cash Payment Method"}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Amount: <span className="amount">GH₵{payment_amount}</span>
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    Amount in Dollars: <span className="amount" > ${(payment_amount * rates).toFixed(2)} </span> 
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    Please click OK below to continue
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={() => {
                    setPaymentMode("");
                    handleCloseCash();
                }}>Cancel</Button>
                <Button onClick={(e)=>{
                    setPaymentMode("Cash");
                    handleCloseCash();
                }} autoFocus>
                    Ok
                </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openPOS}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        onClose(event, reason)
                    }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                disableEscapeKeyDown = {true}
            >
                <DialogTitle id="alert-dialog-title">
                {"POS Payment Method"}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Amount: <span className="amount">GH₵{payment_amount}</span>
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    Amount in Dollars: <span className="amount" > ${(payment_amount * rates).toFixed(2)} </span> 
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    Please click OK below to continue
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={() => {
                    setPaymentMode("");
                    handleClosePOS();
                }}>Cancel</Button>
                <Button onClick={(e)=>{
                    setPaymentMode("Cash");
                    handleClosePOS();
                }} autoFocus>
                    Ok
                </Button>
                </DialogActions>
            </Dialog>
        </div>

        <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="staticBackdropLabel">Transaction Successful</h1>
                    {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
                </div>
                <div className="modal-body">
                    <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={isLoading}
                        >
                            <CircularProgress color="inherit" />
                    </Backdrop>
                    <h5>Thank you for using our service. If you would like to have an account with us so you can manage your subscriptions, click on <span className="text-primary" >Get Started</span> below</h5>
                    
                </div>
                <div className="modal-footer">
                    <a href="/" type="button" className="btn btn-danger">Dismis</a>
                    <a href="/login" type="button" className="btn btn-primary">Get Started</a>
                </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
    
  )
}

export default SelfService